import { ThunkDispatch } from "core-integration/src/store";
import { updateElementControls } from "core-integration/src/store/elements/actions";
import {
  getElementControls,
  getElementsFromControls,
} from "core-integration/src/store/elements/reducers";
import { updateElementControlsAndMaxCost } from "core-integration/src/store/elements/thunks";
import { IElementControls } from "core-integration/src/store/elements/types";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { compareDates, comparePrice } from "../../utils/playerNews";
import { createPageViewData } from "../../utils/tealium";
import ElementFilter from "../element-controls/ElementFilter";
import Paginator, { paginate } from "../element-controls/Paginator";
import { FieldCol, FieldCols } from "../FieldRenderers";
import { Main, Wrapper } from "../Layout";
import InjuryTracker from "../status/InjuryTracker";
import Title from "../Title";
import NbaNewsProvider from "./NbaNewsProvider";

const TitleWrap = styled.div`
  margin-left: ${({ theme }) => theme.space[2]};
  margin-right: ${({ theme }) => theme.space[2]};
`;

const FilterWrap = styled.div`
  width: 100%;
  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    width: 40%;
  }
`;

const News = () => {
  const [page, setPage] = useState(1);
  const { t } = useTranslation();
  const dispatch = useDispatch<ThunkDispatch>();
  const teamsById = useSelector(getTeamsById);
  const controls = useSelector(getElementControls);
  const elements = useSelector(getElementsFromControls);

  const updateControls = (controls: IElementControls) =>
    dispatch(updateElementControls(controls));

  const updateControlsAndMaxCost = (controls: IElementControls) =>
    dispatch(updateElementControlsAndMaxCost(controls));

  const handleFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setPage(1);

    updateControls({
      ...controls,
      filter: e.target.value,
    });
  };

  useEffect(() => {
    updateControlsAndMaxCost({
      ...controls,
      filter: "all",
      getUnavailable: true,
    });
    createPageViewData("player news");
  }, []);

  const { data, totalPages } = paginate(
    elements.data
      ?.filter((element) => element.news !== "")
      .sort(compareDates)
      .sort(comparePrice),
    page,
    15,
  );

  return (
    <>
      <Wrapper>
        <Main>
          <TitleWrap>
            <Title>{t("news.title", "Player News")}</Title>
          </TitleWrap>
          <NbaNewsProvider numberOfArticles={10} />
          <form>
            <FilterWrap>
              <FieldCols>
                <FieldCol>
                  <ElementFilter handleFilterChange={handleFilterChange} />
                </FieldCol>
              </FieldCols>
            </FilterWrap>
          </form>
          <InjuryTracker
            showLink={false}
            teamsById={teamsById}
            elements={data}
            borderBottom={false}
          />
          <Paginator totalPages={totalPages} page={page} setPage={setPage} />
        </Main>
      </Wrapper>
    </>
  );
};

export default News;
